// extracted by mini-css-extract-plugin
export default {"tuzhi-layer-canvas":"LyDUg3VUAzk1xATcxfCL","tuzhiLayerCanvas":"LyDUg3VUAzk1xATcxfCL"};